import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../components/Layout';

// SectionHeader component
const SectionHeader = ({ label, title, align = 'left', className = '' }) => {
  const textAlign = align === 'center' ? 'center' : align === 'right' ? 'right' : 'left';
  return (
    <div className={`mb-8 ${className}`} style={{ textAlign }}>
      {label && <p className="text-sm font-semibold text-primary uppercase tracking-wider mb-2">{label}</p>}
      {title && <h2 className="text-3xl font-bold text-gray-900">{title}</h2>}
    </div>
  );
};

const Showteam = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    '/images/showteam/DSC_0909-2-1024x683.jpg',
    '/images/showteam/Edit-1595-1024x683.jpg',
    '/images/showteam/34963211_1585924861535616_7137807145654812672_n.jpg',
    '/images/showteam/IMG_2606-bewerkt-1024x683.jpg',
    '/images/showteam/Showteam-Honey-Beauty-38-1024x683.jpg',
    '/images/showteam/48032090_2439257479423749_5123961490969198592_o-1024x768.jpg',
    '/images/showteam/Edit-1574-1024x683.jpg',
    '/images/showteam/36200329_1585924938202275_7317565640254947328_n.jpg',
    '/images/showteam/36088073_1585924831535619_2609529508079861760_n.jpg',
    '/images/showteam/56649258_1352715704867102_2440629893394857984_o-1024x683.jpg',
    '/images/showteam/34480936_10160611103745089_6907276777496772608_n-1024x682.jpg',
    '/images/showteam/DSC_0197-1024x683.jpg',
    '/images/showteam/IMG_0973-1024x683.jpg',
    '/images/showteam/Showteam-Honey-Beauty-30-1024x683.jpg',
    '/images/showteam/Showteam-Honey-Beauty-36-1024x683.jpg'
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  }, [carouselImages.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  }, [carouselImages.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <Layout>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-4">Showteam Honey & Beauty</h1>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>“Mini-paarden hebben zo veel in hun mars. Veel meer dan de meeste mensen denken.”</strong>
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8 max-w-3xl">
                Samen met Showteam Honey &amp; Beauty laten we zien hoe veelzijdig, speels en indrukwekkend
                grondwerk met mini-paarden kan zijn.
              </p>
              <a
                href="mailto:kay.ruymaekers@gmail.com"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 transition-colors"
              >
                Contacteer ons
              </a>
            </div>
            <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-lg shadow-xl">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/b0YFQGJrbes"
                title="Showteam Honey & Beauty"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Plezier Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <SectionHeader label="Onze aanpak" title="Plezier op de eerste plaats!" align="center" className="mb-6" />
          <p className="text-lg text-gray-700 leading-relaxed mb-4 max-w-3xl mx-auto">
            Samen met <strong><a className="text-primary hover:text-primary/80" href="https://www.facebook.com/Ingrid-Vandamme-paarden-connectie-266699617265522/" target="_blank" rel="noopener noreferrer">Ingrid Vandamme</a></strong> reis ik de Benelux rond om aan iedereen te tonen dat mini-paarden veel meer in hun mars hebben dan de meeste mensen denken.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-4 max-w-3xl mx-auto">
            Op vrolijke deuntjes laten we een variatie zien van wat wij allemaal leuk vinden om te doen met onze paardjes.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-4 max-w-3xl mx-auto">
            Ieder persoon en paard is uniek, dat is bij ons niet anders. Doorheen de shows en demonstraties is die eigenheid net wat zorgt voor een optimale mix van onze eigen talenten.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Als leuke bonus kan iedereen zien dat clickertraining werkt!
          </p>
        </div>
      </section>

      {/* Image Carousel */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader label="Galerij" title="Foto’s van het showteam" align="center" className="mb-10" />
          <div className="relative">
            <div className="overflow-hidden rounded-lg shadow-xl">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {carouselImages.map((image, index) => (
                  <div key={index} className="min-w-full">
                    <img
                      src={image}
                      alt={`Showteam Honey & Beauty ${index + 1}`}
                      className="w-full h-auto object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
              aria-label="Previous slide"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
              aria-label="Next slide"
            >
              <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default Showteam;
